import type { Constructor, INode, IRenderContext, Rect } from '@ardoq/yfiles';
import { ArdoqIcon } from '@ardoq/icons';
import { LeafNodeVisual } from './leafNode/LeafNodeVisual';
import { ModernizedNodeStyleBase } from './ModernizedNodeStyleBase';
import {
  buildLeafProps,
  createNodeExportSupportLookup,
  getColor,
} from './leafNode/util';

class IconNodeStyle extends ModernizedNodeStyleBase {
  private readonly nodeExportSupportLookup = createNodeExportSupportLookup(
    (context, node) => this.getLayout(context, node)
  );
  constructor(private icon: ArdoqIcon) {
    super();
  }

  protected getLayout(context: IRenderContext, node: INode): Rect {
    const props = buildLeafProps(node, context, { icon: this.icon });
    return LeafNodeVisual.getLayout(props);
  }

  protected override lookup(node: INode, type: Constructor): unknown {
    return this.nodeExportSupportLookup(node, type) ?? super.lookup(node, type);
  }

  override createVisual(context: IRenderContext, node: INode) {
    const props = buildLeafProps(node, context, {
      icon: this.icon,
    });
    const color = getColor(node);
    return new LeafNodeVisual({
      ...props,
      color,
    });
  }
}

export { IconNodeStyle };
